import { render, staticRenderFns } from "./MemberNew.vue?vue&type=template&id=4ed67e16"
import script from "./MemberNew.vue?vue&type=script&lang=js"
export * from "./MemberNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports